function getGrowthBaseUrlFromEnv(env: string | undefined): string {
  let baseUrl = 'https://growth-api.fabfitfun.com';
  switch (env) {
    case 'dev':
      baseUrl = 'https://growth-api.fff-dev.com';
      break;
    case 'qa':
      baseUrl = 'https://growth-api.fff-qa.com';
      break;
    default:
      break;
  }
  return baseUrl;
}

export default getGrowthBaseUrlFromEnv;
